<style lang="scss">
	#amygu{
		.lineChart{
		    width: 100%;
		    height: 350px;
		    display: inline-block;
		    background-color: #1e094e;
		    box-shadow: 0 2px 12px 0 rgba(30,9,78, 1);
		}
	}
    .ratio_class{
		height: 450px !important;
	}
	@media screen and (min-width:2200px){
		.ratio_class{
			height: 600px !important;
		}
	}
</style>

<template>
    <div id='amygu'>
        <div  :class="{ratio_class : useData.id == 'barChart3'}" class="lineChart Chart" :id="useData.id"></div>
    </div>
</template>
<script>
    export default {
        name: 'lineChart',
        props: ['dataBol','useData','widthPxMess'],
        data(){
            return {
         
            }
        },
        watch: {
            'dataBol': {
                handler (n) {
                    let _this = this;
                    if(n){
                        let myChart = _this.$echarts.init(document.getElementById(_this.useData.id));
                        _this.myChart = myChart;
                        _this.drawChart();  
                    }
                }
            }
        },
        mounted() {
		},
		methods: {
            drawChart(){
                let _this = this;
                _this.myChart.setOption({
                    title:{
                        text:_this.useData.title,
                        textStyle:{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontSize:_this.widthPxMess.titleSize,
                        },
                        x:'center',
                        y:'20',
                    },
                    grid:{
                        top:'25%',
                    },
                    legend: {
                        icon:'none',
                        textStyle:{
                            color: '#a9a5b5',
                            fontSize:_this.widthPxMess.XYSize
                        },
                        formatter: function () {
                            return _this.useData.ckname
							// '貨幣單位：HKD(W)'
                        },
                        right: 20,
                        top:'15%'
                    },
                    animation: true,
                    xAxis: {
                        data: _this.useData.x,
                        boundaryGap: false,
                        axisTick:{
                            show:false,
                        },
                        axisLine: {
                            show:false,
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        axisLabel:{
                            interval:0,
                            fontSize:_this.widthPxMess.XYSize,
                            margin:20
                        }
                    },
                    yAxis: {
                        name: '人數',
                        nameTextStyle: {
                            padding: [0, 30, 0, 0]    // 四个数字分别为上右下左与原位置距离
                        },
                        axisTick:{
                            show:false,
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#311878',
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            show:false,
                            lineStyle: {
                                color: '#ccc',
                            }
                        },
                        axisLabel:{
                            fontSize:_this.widthPxMess.XYSize
                        },
                        minInterval:1,
                    },
                    series: _this.useData.series
					// [{
					//     name: '模拟数据',
					//     type: 'line',
					//     smooth: true,
					//     itemStyle: {
					//         color: '#36f3ff',
					//         opacity:0.7
					//     },
					//     areaStyle: {
					// 		 opacity: 0.8,
					//         color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
					//             offset: 0,
					//             color: '#276493'
					//         }, {
					//             offset: 1,
					//             color: '#1e0b4f'
					//         }]),
					//     },
					//     data: _this.useData.data
					// }]
                })
            }
        }
    }
</script>